import { type FC } from 'react'

import { productSearchAlgoliaAccessorGetFormattedUnitQuantity } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetFormattedUnitQuantity'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

import { productSearchResultItemFactsSwitcher } from './productSearchResultItemFactsSwitcher'

export const ProductSearchResultItemFacts: FC = () => {
  const { algoliaRecord: item } = useProductSearchResultItemContext()

  const factIdSwitcher = productSearchResultItemFactsSwitcher(item)
  const formattedUnitQuantity =
    productSearchAlgoliaAccessorGetFormattedUnitQuantity(item)

  return (
    <div className="flex flex-col gap-1 pl-4">
      <ul className="list-disc">
        {formattedUnitQuantity ? (
          <li className="text-xs text-dark-primary-max">
            {formattedUnitQuantity}{' '}
            {item.pharmaForm ? ` | ${item.pharmaForm}` : ''}
          </li>
        ) : null}

        {factIdSwitcher ? (
          <li className="text-xs text-dark-primary-strong">
            {factIdSwitcher.formattedMessage}
            {': '}
            {factIdSwitcher.value}
          </li>
        ) : null}

        {item.manufacturer ? (
          <li className="text-xs text-dark-primary-strong">
            {item.manufacturer}
          </li>
        ) : null}
      </ul>
    </div>
  )
}
